(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dc-dynamic-hub"]) return;
  try {
    
(function () {
  const SECTION_KEY = 'dc-hub-search-results';

  function getSectionHtml(data, key) {
    if (!data) return null;
    if (typeof data === 'string') return data;
    if (data[key]) return data[key];
    if (data.sections && data.sections[key]) return data.sections[key];
    return null;
  }

  function buildSearchPageUrl(baseUrl, tag, page, sortBy) {
    const root = (baseUrl || '/search').replace(/\/$/, '');
    const params = new URLSearchParams({
      q: 'tag:' + tag,
      type: 'product',
    });
    if (sortBy) params.set('sort_by', sortBy);
    if (page > 1) params.set('page', String(page));
    return root + '?' + params.toString();
  }

  function buildSearchUrl(baseUrl, tag, page, mode, sortBy) {
    const root = (baseUrl || '/search').replace(/\/$/, '');
    const params = new URLSearchParams({
      q: 'tag:' + tag,
      type: 'product',
    });

    if (sortBy) params.set('sort_by', sortBy);

    if (mode === 'sections') {
      params.set('sections', SECTION_KEY);
    } else {
      params.set('section_id', SECTION_KEY);
    }

    if (page > 1) params.set('page', String(page));

    return root + '?' + params.toString();
  }

  async function fetchSectionHtml(url) {
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error('HTTP ' + response.status);
    }

    const contentType = response.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
      const data = await response.json();
      const html = getSectionHtml(data, SECTION_KEY);
      if (html === null || html === undefined) {
        throw new Error('Section key missing in JSON response');
      }
      return html;
    }

    return response.text();
  }

  function initHub(hub) {
    const tag = hub.dataset.productTag;
    if (!tag) return;

    const resultsEl = hub.querySelector('[data-dc-hub-results]');
    if (!resultsEl) return;

    const searchUrl = hub.dataset.searchUrl || '/search';
    const columnsDesktop = hub.dataset.columnsDesktop || '4';
    const columnsMobile = hub.dataset.columnsMobile || '2';
    const sortBy = hub.dataset.sortBy || 'created-ascending';

    async function loadProducts() {
      resultsEl.innerHTML =
        '<p class="dc-dynamic-hub__loading center">Loading products…</p>';

      const urls = [
        buildSearchUrl(searchUrl, tag, 1, 'sections', sortBy),
        buildSearchUrl(searchUrl, tag, 1, 'section_id', sortBy),
      ];

      let html = null;
      let lastError = null;

      for (const url of urls) {
        try {
          html = await fetchSectionHtml(url);
          if (html && html.trim()) break;
        } catch (error) {
          lastError = error;
        }
      }

      if (!html || !html.trim()) {
        console.error('dc-dynamic-hub: failed to load section', lastError);
        resultsEl.innerHTML =
          '<p class="dc-dynamic-hub__no-results center">Could not load products. ' +
          '<a href="' +
          buildSearchPageUrl(searchUrl, tag, 1, sortBy) +
          '">View search results</a></p>';
        return;
      }

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const gridWrap = doc.querySelector('[data-dc-hub-grid]');

      if (gridWrap) {
        resultsEl.innerHTML = gridWrap.innerHTML;
        const grid = resultsEl.querySelector('.product-grid');
        if (grid) {
          grid.classList.forEach((cls) => {
            if (cls.match(/^grid--\d+-col-/)) grid.classList.remove(cls);
          });
          grid.classList.add('grid--' + columnsDesktop + '-col-desktop');
          grid.classList.add('grid--' + columnsMobile + '-col-tablet-down');
        }
      } else {
        const errorMsg = doc.querySelector('[data-dc-hub-error]');
        resultsEl.innerHTML = errorMsg
          ? errorMsg.outerHTML
          : '<p class="dc-dynamic-hub__no-results center">No products found with tag <strong>' +
            tag +
            '</strong>. Check the tag spelling (case-sensitive).</p>';
      }
    }

    loadProducts();
  }

  function initAll() {
    document.querySelectorAll('[data-dc-dynamic-hub]').forEach(initHub);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
